import React from "react";

// Card de Condonación de intereses del dashboard — dona con % de interés total condonado, y
// dos barras (normal/moratorio) mostrando el condonado sobre el total de cada tipo.
// data viene de DashboardIndicadoresGraficas/ObtenerInfoGraficas -> intereses_condonados
// (mdl_Intereses_Condonados). Si aún no llega, se usan valores de ejemplo.
const FormatMoneyMXN = (valor) =>
    `$${Number(valor || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`;

export const ChartCondonacionIntereses = ({ data }) => {
    const totalInteresNormal = data?.total_interes_normal ?? 0;
    const totalInteresMoratorio = data?.total_interes_moratorio ?? 0;
    const totalIntereses = data?.total_intereses ?? (totalInteresNormal + totalInteresMoratorio);
    const normalCondonado = data?.total_interes_normal_condonado ?? 0;
    const moratorioCondonado = data?.total_interes_moratorio_condonado ?? 0;
    const totalCondonado = data?.total_interes_condonado ?? (normalCondonado + moratorioCondonado);

    // % de cada tipo sobre el total de intereses — determina el corte de la dona.
    const pctNormalSobreTotal = totalIntereses ? (normalCondonado / totalIntereses) * 100 : 0;
    const pctMoratorioSobreTotal = totalIntereses ? (moratorioCondonado / totalIntereses) * 100 : 0;
    const pctCondonadoTotal = totalIntereses ? (totalCondonado / totalIntereses) * 100 : 0;

    // % condonado dentro de cada tipo — el que se muestra en su propia barra.
    const pctNormal = totalInteresNormal ? (normalCondonado / totalInteresNormal) * 100 : 0;
    const pctMoratorio = totalInteresMoratorio ? (moratorioCondonado / totalInteresMoratorio) * 100 : 0;

    const corteNormal = pctNormalSobreTotal;
    const corteMoratorio = pctNormalSobreTotal + pctMoratorioSobreTotal;

    return (
        <div className="condonacion-intereses-card">
            <div className="condonacion-intereses-header">
                Condonación de intereses
            </div>

            <div className="condonacion-intereses-body">
                <div className="condonacion-intereses-total">
                    Interés total: {FormatMoneyMXN(totalIntereses)}
                </div>

                <div className="condonacion-intereses-fila">
                    <div
                        className="condonacion-intereses-dona"
                        style={{
                            background: `conic-gradient(#2e7d4f 0% ${corteNormal}%, #e0a51c ${corteNormal}% ${corteMoratorio}%, #d9d9d9 ${corteMoratorio}% 100%)`,
                        }}
                    >
                        <div className="condonacion-intereses-dona-centro">
                            <span className="condonacion-intereses-dona-pct">{pctCondonadoTotal.toFixed(1)}%</span>
                            <span className="condonacion-intereses-dona-label">condonado</span>
                        </div>
                    </div>

                    <div className="condonacion-intereses-leyenda">
                        <div className="condonacion-intereses-leyenda-fila">
                            <div className="condonacion-intereses-leyenda-linea">
                                <span className="condonacion-intereses-punto" style={{ background: "#2e7d4f" }} />
                                <span className="condonacion-intereses-leyenda-label">Normal condonado</span>
                                <span className="condonacion-intereses-leyenda-monto">
                                    {FormatMoneyMXN(normalCondonado)} / {FormatMoneyMXN(totalInteresNormal)} ({pctNormal.toFixed(1)}%)
                                </span>
                            </div>
                            <div className="condonacion-intereses-barra">
                                <div className="condonacion-intereses-barra-relleno" style={{ width: `${pctNormal}%`, background: "#2e7d4f" }} />
                            </div>
                        </div>

                        <div className="condonacion-intereses-leyenda-fila">
                            <div className="condonacion-intereses-leyenda-linea">
                                <span className="condonacion-intereses-punto" style={{ background: "#e0a51c" }} />
                                <span className="condonacion-intereses-leyenda-label">Moratorio condonado</span>
                                <span className="condonacion-intereses-leyenda-monto">
                                    {FormatMoneyMXN(moratorioCondonado)} / {FormatMoneyMXN(totalInteresMoratorio)} ({pctMoratorio.toFixed(1)}%)
                                </span>
                            </div>
                            <div className="condonacion-intereses-barra">
                                <div className="condonacion-intereses-barra-relleno" style={{ width: `${pctMoratorio}%`, background: "#e0a51c" }} />
                            </div>
                        </div>

                        <div className="condonacion-intereses-leyenda-fila">
                            <div className="condonacion-intereses-leyenda-linea">
                                <span className="condonacion-intereses-punto" style={{ background: "#1a4d2e" }} />
                                <span className="condonacion-intereses-leyenda-label">Total condonado</span>
                                <span className="condonacion-intereses-leyenda-monto">
                                    {FormatMoneyMXN(totalCondonado)} / {FormatMoneyMXN(totalIntereses)} ({pctCondonadoTotal.toFixed(1)}%)
                                </span>
                            </div>
                            <div className="condonacion-intereses-barra">
                                <div className="condonacion-intereses-barra-relleno" style={{ width: `${pctCondonadoTotal}%`, background: "#1a4d2e" }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="condonacion-intereses-resumen">
                    <span className="condonacion-intereses-resumen-label">Total condonado</span>
                    <span className="condonacion-intereses-resumen-valor">
                        {FormatMoneyMXN(totalCondonado)} <span className="condonacion-intereses-resumen-pct">({pctCondonadoTotal.toFixed(1)}%)</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ChartCondonacionIntereses;
